import { Component, inject, PLATFORM_ID } from '@angular/core';
import { DOCUMENT, isPlatformBrowser } from '@angular/common';
import { ConfigService, ZoneService } from '@gallaghercp/core-frontend';

@Component({
    selector: 'core-top-notification-banner',
    templateUrl: './notification-banner.component.html',
    styleUrls: ['./notification-banner.component.scss'],
    standalone: false,
})
export class NotificationBannerComponent {
    protected config = inject(ConfigService);
    protected zoneService = inject(ZoneService);
    private document: Document = inject(DOCUMENT);
    private platformId = inject(PLATFORM_ID);

    get showBanner(): boolean {
        const allowedZones: number[] = (this.config.get('notificationBanner') as any)?.allowedZones || [];
        const currentZone = this.zoneService.getCurrentZone() as any;
        const zoneId: number | undefined = currentZone?.zone || currentZone?.id;

        const shouldShow = allowedZones.length > 0 ? zoneId !== undefined && allowedZones.includes(zoneId) : true;

        // Set the CSS var in sync with evaluation so layout updates immediately
        if (isPlatformBrowser(this.platformId)) {
            const value = shouldShow ? (this.bannerHeight ?? '3.75rem') : '0rem';
            this.document.documentElement.style.setProperty('--header-height-notification-banner', value as string);
        }

        return shouldShow;
    }

    get bannerText(): string {
        return (this.config.get('notificationBanner') as any)?.text || '';
    }

    get bannerBackgroundColor(): string | null {
        return (this.config.get('notificationBanner') as any)?.backgroundColor || null;
    }

    get bannerTextColor(): string | null {
        return (this.config.get('notificationBanner') as any)?.textColor || null;
    }

    get bannerHeight(): string | null {
        return (this.config.get('notificationBanner') as any)?.height || '3.75rem';
    }
}
